import Vue from 'vue';
import Vuex from 'vuex';
import VueClipboard from 'vue-clipboard2';

import state from './state';
import mutations from './mutations';
import actions from './actions';

Vue.use(Vuex);
Vue.use(VueClipboard);

export default new Vuex.Store({
    state,
    mutations,
    actions
});
